<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon
        class="icon-style"
        left
      >
        mdi-account-lock
      </v-icon> Account Control
    </h2>
    <br>
    <v-tabs
      v-model="tab"
      color="#FF3700"
      background-color="#ECEFF1"
    >
      <v-tab
        v-for="item in items"
        :key="item.tab"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab"
      class="my-tabs-background-style"
    >
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
      >
        <v-card-text>
          <component :is="item.content" />
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import RolesList from 'src/views/dashboard/settings/RolesList.vue';
  import PermissionsList from 'src/views/dashboard/settings/PermissionsList.vue';
  export default {
    name: 'AccountControl',
    components: {
      RolesList,
      PermissionsList,
    },
    data: () => ({
      tab: null,
      items: [
        { tab: 'Roles', content: RolesList },
        { tab: 'Permissions', content: PermissionsList },
      ],
    }),
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-tabs-background-style {
    background-color: #ECEFF1 !important;
}
</style>
